import { apiClient } from './apiClient';
import type {
  SeniorFeedbackReviewer,
  EligibleSeniorReviewer,
  AddSeniorReviewerRequest,
  UpdateSeniorFeedbackRequest,
} from './types/jobEnd.types';

export const seniorFeedbackApi = {
  getByJobEnd: async (jobEndId: number): Promise<SeniorFeedbackReviewer[]> => {
    try {
      return await apiClient.get(`/job-ends/${jobEndId}/senior-feedback`).then((res) => res.data);
    } catch (error) {
      console.error('Failed to fetch senior feedbacks:', error);
      throw error;
    }
  },

  getEligibleReviewers: async (jobEndId: number): Promise<EligibleSeniorReviewer[]> => {
    try {
      return await apiClient.get(`/job-ends/${jobEndId}/eligible-senior-reviewers`).then((res) => res.data);
    } catch (error) {
      console.error('Failed to fetch eligible senior reviewers:', error);
      throw error;
    }
  },

  addReviewer: async (
    jobEndId: number,
    request: AddSeniorReviewerRequest
  ): Promise<SeniorFeedbackReviewer> => {
    try {
      const res = await apiClient.post(`/job-ends/${jobEndId}/senior-feedback`, request);
      return res.data;
    } catch (error) {
      console.error('Failed to add senior reviewer:', error);
      throw error;
    }
  },

  updateFeedback: async (
    feedbackId: number,
    request: UpdateSeniorFeedbackRequest,
    rowVersion?: string
  ): Promise<SeniorFeedbackReviewer> => {
    try {
      const res = await apiClient.put(`/senior-feedback/${feedbackId}`, { ...request, rowVersion });
      return res.data;
    } catch (error) {
      console.error('Failed to update senior feedback:', error);
      throw error;
    }
  },

  deleteReviewer: async (feedbackId: number): Promise<void> => {
    try {
      await apiClient.delete(`/senior-feedback/${feedbackId}`);
    } catch (error) {
      console.error('Failed to delete senior reviewer:', error);
      throw error;
    }
  },

};
